import "@/App.css";
import { HelmetProvider } from "react-helmet-async";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { SportProvider } from "@/context/SportContext";
import Header from "@/components/Header";
import AddToHomeScreen from "@/components/AddToHomeScreen";
import NavControls from "@/components/NavControls";
import Footer from "@/components/Footer";
import DetailBottomAd from "@/components/DetailBottomAd";
import ScrollManager from "@/components/ScrollManager";
import AdSideRail from "@/components/AdSideRail";
import Landing from "@/pages/Landing";
import TeamDetail from "@/pages/TeamDetail";
import TeamEditPage from "@/pages/TeamEditPage";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import RegisterPlayer from "@/pages/RegisterPlayer";
import RegisterTeam from "@/pages/RegisterTeam";
import RegisterScout from "@/pages/RegisterScout";
import RegisterTrainer from "@/pages/RegisterTrainer";
import Favorites from "@/pages/Favorites";
import PlayerDetail from "@/pages/PlayerDetail";
import SlugRedirect from "@/pages/SlugRedirect";
import SportSlugRouter from "@/pages/SportSlugRouter";
import Profile from "@/pages/Profile";
import TrainerDetail from "@/pages/TrainerDetail";
import TrainerListingDetail from "@/pages/TrainerListingDetail";
import Admin from "@/pages/Admin";
import Account from "@/pages/Account";
import Terms from "@/pages/Terms";
import Privacy from "@/pages/Privacy";
import Add from "@/pages/Add";
import EventDetail from "@/pages/EventDetail";
import Alerts from "@/pages/Alerts";
import AlertUnsubscribe from "@/pages/AlertUnsubscribe";
import UserBoard from "@/pages/UserBoard";
import Feed from "@/pages/Feed";
import Trending from "@/pages/Trending";
import Tags from "@/pages/Tags";
import Contact from "@/pages/Contact";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import VerifyEmail from "@/pages/VerifyEmail";
import NotificationCenter from "@/pages/NotificationCenter";
import TosModal from "@/components/TosModal";
import ConsentBanner from "@/components/ConsentBanner";
import AuthCallback from "@/pages/AuthCallback";
import GoogleOAuthCallback from "@/pages/GoogleOAuthCallback";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import { ThemeProvider } from "@/context/ThemeContext";

export default function App() {
    return (
        <HelmetProvider>
        <div className="App min-h-screen flex flex-col overflow-x-clip">
            <BrowserRouter>
                <ScrollManager />
                <ThemeProvider>
                <AuthProvider>
                    <SportProvider>
                        <Header />
                        <NavControls />
                        <AddToHomeScreen />
                    <main className="flex-1">
                        <Routes>
                            <Route path="/" element={<Landing />} />
                            <Route path="/payment/success" element={<PaymentSuccess />} />
                            <Route path="/payment/cancel" element={<PaymentCancel />} />
                            <Route path="/teams/:id" element={<TeamDetail />} />
                            <Route path="/teams/:id/edit" element={<TeamEditPage />} />
                            <Route path="/teams/:id/edit" element={<Navigate to=".." relative="path" replace />} />
                            <Route path="/login" element={<Login />} />
                            <Route path="/auth/callback" element={<AuthCallback />} />
                            <Route path="/auth/google" element={<GoogleOAuthCallback />} />
                            <Route path="/register" element={<Register />} />
                            <Route path="/register/player" element={<RegisterPlayer />} />
                            <Route path="/register/team" element={<RegisterTeam />} />
                            <Route path="/register/scout" element={<RegisterScout />} />
                            <Route path="/register/trainer" element={<RegisterTrainer />} />
                            <Route path="/favorites" element={<Favorites />} />
                            <Route path="/players/:id" element={<PlayerDetail />} />
                            <Route path="/profile" element={<Profile />} />
                            <Route path="/trainers/:id" element={<TrainerDetail />} />
                            <Route path="/trainer-listings/:id" element={<TrainerListingDetail />} />
                            <Route path="/admin" element={<Admin />} />
                            <Route path="/account" element={<Account />} />
                            <Route path="/terms" element={<Terms />} />
                            <Route path="/privacy" element={<Privacy />} />
                            <Route path="/add" element={<Add />} />
                            <Route path="/add/:sport" element={<Add />} />
                            <Route path="/events/:id" element={<EventDetail />} />
                            <Route path="/alerts/unsubscribe" element={<AlertUnsubscribe />} />
                            <Route path="/alerts" element={<Alerts />} />
                            <Route path="/notifications" element={<NotificationCenter />} />
                            <Route path="/feed" element={<Feed />} />
                            <Route path="/trending" element={<Trending />} />
                            <Route path="/tags/:tag" element={<Tags />} />
                            <Route path="/contact" element={<Contact />} />
                            <Route path="/forgot-password" element={<ForgotPassword />} />
                            <Route path="/reset-password" element={<ResetPassword />} />
                            <Route path="/verify-email" element={<VerifyEmail />} />
                            <Route path="/u/:username" element={<UserBoard />} />
                            {/* Path-based sport pages + Pro custom listing URLs.
                                Static routes above always win by React Router specificity ranking. */}
                            <Route path="/:sport/:slug" element={<SportSlugRouter />} />
                            <Route path="/:sport" element={<Landing />} />
                            {/* Catch-all: unknown paths (including the retired /teams and /trainers list routes) return to the Landing directory. */}
                            <Route path="*" element={<Navigate to="/" replace />} />
                        </Routes>
                    </main>
                    <DetailBottomAd />
                    <Footer />
                    <AdSideRail />
                    <TosModal />
                    <ConsentBanner />
                    <Toaster
                        theme="dark"
                        position="top-right"
                        toastOptions={{
                            style: {
                                background: "#141414",
                                border: "1px solid #2a2a2a",
                                color: "#fff",
                                borderRadius: 0,
                            },
                        }}
                    />
                    </SportProvider>
                </AuthProvider>
                </ThemeProvider>
            </BrowserRouter>
        </div>
        </HelmetProvider>
    );
}
